import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/page/hotel/index.tsx");
